"use client";
import { grey } from "@mui/material/colors";
import { createTheme, ThemeOptions } from "@mui/material/styles";
import {
  ERROR_ACCENT_COLOR,
  ERROR_COLOR,
  NEUTRO_OVERLINE_COLOR,
  NEUTRO_PARAGRAPHS_COLOR,
  PRIMARY_BRAND_VARIANT_COLOR,
  PRIMARY_BUTTON_COLOR,
  WARNING_COLOR,
} from "@/utils/constants";

export const themeOptions: ThemeOptions = {
  components: {
    MuiRadio: {
      styleOverrides: {
        root: {
          "&:hover": {
            // backgroundColor: PRIMARY_BUTTON_COLOR,
            color: PRIMARY_BUTTON_COLOR,
            // padding: "0px",
            "& .MuiSvgIcon-root": {
              fill: `${PRIMARY_BUTTON_COLOR} !important`, // Cambia el color del icono al hover
            },
          },
          "@media (max-width:600px)": {},
          // Estilos para dispositivos medianos y grandes
          "@media (min-width:960px)": {},
        },
      },
    },
  },
  typography: {
    fontFamily: ["Roobert", "sans-serif"].join(","),
    fontSize: 14,
    fontWeightRegular: 300,
    fontWeightMedium: 400,
    fontWeightBold: 500,
    h1: {
      fontSize: "32px",
      fontWeight: 600,
      lineHeight: "36px",
    },
    h2: {
      fontSize: "1.2rem",
      fontWeight: 400,
    },
    h3: {
      fontSize: "1.1rem",
      fontWeight: 900,
    },
    h4: {
      fontSize: "18px",
      fontWeight: 500,
      ineHeight: "24px",
    },
    h5: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "22px",
    },
    h6: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "16px",
    },
    body1: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "16px",
    },
    body2: {
      fontSize: "0.9rem",
      fontWeight: 900,
    },
    button: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "22px",
    },
    caption: {
      fontSize: "0.8rem",
      fontWeight: 400,
    },
    subtitle1: {
      fontSize: "18px",
      fontWeight: 400,
      lineHeight: "26px",
    },
    subtitle2: {
      fontSize: "16px",
      fontWeight: 300,
      lineHeight: "22px",
    },
  },
  palette: {
    mode: "light",
    primary: {
      main: PRIMARY_BUTTON_COLOR,
      dark: NEUTRO_OVERLINE_COLOR,
    },
    error: {
      main: ERROR_COLOR,
      light: ERROR_ACCENT_COLOR,
    },
    info: {
      main: PRIMARY_BRAND_VARIANT_COLOR,
      light: PRIMARY_BRAND_VARIANT_COLOR,
    },
    success: {
      main: PRIMARY_BRAND_VARIANT_COLOR,
      light: PRIMARY_BRAND_VARIANT_COLOR,
    },
    warning: {
      main: WARNING_COLOR,
      light: ERROR_ACCENT_COLOR,
    },
    common: {
      white: "#FFF",
      black: NEUTRO_OVERLINE_COLOR,
    },
    action: {
      active: "#0f5a10",
      selected: "#0f5a10",
    },
    background: {
      default: "#FFF",
      paper: "#F8F8F8",
    },
    divider: grey[200],
    text: {
      primary: "#262423",
      secondary: NEUTRO_PARAGRAPHS_COLOR,
    },
  },
};

// @ts-ignore
const theme = createTheme(themeOptions);

export default theme;
